// W17-FORM-ERRORS-NOTIFICATIONS-20261019 · the design-compiled booking surface's adapter to the SHARED form feedback.
//
// CARD DETAILS (purchaser fields, terms) is rendered by the exported design (sg-beta-v2.01.html), whose logic block
// cannot import. DesignSurface publishes this object on `window.__SG_FORM_FEEDBACK` (the same seam as
// __SG_SIGNUP_POLICY) and the export takes every reveal / clear / summary / focus decision from it. The behaviour
// itself is packages/ui lib/form-feedback — the same functions field.tsx and the in-page card panel use — so nothing
// here restates it. Unpublished (the standalone design tool), the export keeps its one-line notice.
import {
  FIELD_ERROR_COLOR,
  errorSummaryTitle,
  focusFirstError,
  revealOnBlur,
  revealOnSubmit,
  settleOnChange,
  visibleErrors,
} from "@repo/ui/lib/form-feedback";

export interface DesignFormFeedback {
  errorColor: string;
  revealOnBlur(revealed: readonly string[], key: string): string[];
  settleOnChange(revealed: readonly string[], key: string, valid: boolean): string[];
  revealOnSubmit(revealed: readonly string[], errorKeys: readonly string[]): string[];
  visibleErrors(errors: Readonly<Record<string, string | null | undefined>>, revealed: readonly string[]): Record<string, string>;
  summaryTitle(count: number): string;
  /** After the state that shows the errors has painted: scroll to and focus the first of `ids` that is on the page. */
  focusFirst(ids: readonly string[]): void;
}

export const designFormFeedback: DesignFormFeedback = {
  errorColor: FIELD_ERROR_COLOR,
  revealOnBlur,
  settleOnChange,
  revealOnSubmit,
  visibleErrors,
  summaryTitle: errorSummaryTitle,
  focusFirst: (ids) => {
    if (typeof window === "undefined") return;
    window.requestAnimationFrame(() => {
      focusFirstError(ids, { document, matchMedia: (q) => window.matchMedia(q) });
    });
  },
};

declare global {
  interface Window {
    __SG_FORM_FEEDBACK?: DesignFormFeedback;
  }
}
